import {escapeCharacters} from './utils'

/** WARNING: PROFANE WORDS BELOW **/

// Copied from https://github.com/MauriceButler/badwords
const badwords = [
  '4r5e',
  '5h1t',
  '5hit',
  'a55',
  'anal',
  'anus',
  'ar5e',
  'arrse',
  'arse',
  'ass',
  'ass-fucker',
  'asses',
  'assfucker',
  'assfukka',
  'asshole',
  'assholes',
  'asswhole',
  'a_s_s',
  'b!tch',
  'b00bs',
  'b17ch',
  'b1tch',
  'ballbag',
  'balls',
  'ballsack',
  'bastard',
  'beastial',
  'beastiality',
  'bellend',
  'bestial',
  'bestiality',
  'bi+ch',
  'biatch',
  'bitch',
  'bitcher',
  'bitchers',
  'bitches',
  'bitchin',
  'bitching',
  'bloody',
  'blow job',
  'blowjob',
  'blowjobs',
  'boiolas',
  'bollock',
  'bollok',
  'boner',
  'boob',
  'boobs',
  'booobs',
  'boooobs',
  'booooobs',
  'booooooobs',
  'breasts',
  'buceta',
  'bugger',
  'bum',
  'bunny fucker',
  'butthole',
  'buttmuch',
  'buttplug',
  'c0ck',
  'c0cksucker',
  'carpet muncher',
  'cawk',
  'chink',
  'cipa',
  'cl1t',
  'clit',
  'clitoris',
  'clits',
  'cnut',
  'cock',
  'cock-sucker',
  'cockface',
  'cockhead',
  'cockmunch',
  'cockmuncher',
  'cocks',
  'cocksuck',
  'cocksucked',
  'cocksucker',
  'cocksucking',
  'cocksucks',
  'cocksuka',
  'cocksukka',
  'cok',
  'cokmuncher',
  'coksucka',
  'coon',
  'cox',
  'crap',
  'cum',
  'cummer',
  'cumming',
  'cums',
  'cumshot',
  'cunilingus',
  'cunillingus',
  'cunnilingus',
  'cunt',
  'cuntlick',
  'cuntlicker',
  'cuntlicking',
  'cunts',
  'cyalis',
  'cyberfuc',
  'cyberfuck',
  'cyberfucked',
  'cyberfucker',
  'cyberfuckers',
  'cyberfucking',
  'd1ck',
  'damn',
  'dick',
  'dickhead',
  'dildo',
  'dildos',
  'dink',
  'dinks',
  'dirsa',
  'dlck',
  'dog-fucker',
  'doggin',
  'dogging',
  'donkeyribber',
  'doosh',
  'duche',
  'dyke',
  'ejaculate',
  'ejaculated',
  'ejaculates',
  'ejaculating',
  'ejaculatings',
  'ejaculation',
  'ejakulate',
  'f u c k',
  'f u c k e r',
  'f4nny',
  'fag',
  'fagging',
  'faggitt',
  'faggot',
  'faggs',
  'fagot',
  'fagots',
  'fags',
  'fanny',
  'fannyflaps',
  'fannyfucker',
  'fanyy',
  'fatass',
  'fcuk',
  'fcuker',
  'fcuking',
  'feck',
  'fecker',
  'felching',
  'fellate',
  'fellatio',
  'fingerfuck',
  'fingerfucked',
  'fingerfucker',
  'fingerfuckers',
  'fingerfucking',
  'fingerfucks',
  'fistfuck',
  'fistfucked',
  'fistfucker',
  'fistfuckers',
  'fistfucking',
  'fistfuckings',
  'fistfucks',
  'flange',
  'fook',
  'fooker',
  'fuck',
  'fucka',
  'fucked',
  'fucker',
  'fuckers',
  'fuckhead',
  'fuckheads',
  'fuckin',
  'fucking',
  'fuckings',
  'fuckingshitmotherfucker',
  'fuckme',
  'fucks',
  'fuckwhit',
  'fuckwit',
  'fudge packer',
  'fudgepacker',
  'fuk',
  'fuker',
  'fukker',
  'fukkin',
  'fuks',
  'fukwhit',
  'fukwit',
  'fux',
  'fux0r',
  'f_u_c_k',
  'gangbang',
  'gangbanged',
  'gangbangs',
  'gaylord',
  'gaysex',
  'goatse',
  'god-dam',
  'god-damned',
  'goddamn',
  'goddamned',
  'hardcoresex',
  'hell',
  'heshe',
  'hoar',
  'hoare',
  'hoer',
  'homo',
  'hore',
  'horniest',
  'horny',
  'hotsex',
  'jack-off',
  'jackoff',
  'jap',
  'jerk-off',
  'jism',
  'jiz',
  'jizm',
  'jizz',
  'kawk',
  'knob',
  'knobead',
  'knobed',
  'knobend',
  'knobhead',
  'knobjocky',
  'knobjokey',
  'kock',
  'kondum',
  'kondums',
  'kum',
  'kummer',
  'kumming',
  'kums',
  'kunilingus',
  'l3i+ch',
  'l3itch',
  'labia',
  'lust',
  'lusting',
  'm0f0',
  'm0fo',
  'm45terbate',
  'ma5terb8',
  'ma5terbate',
  'masochist',
  'master-bate',
  'masterb8',
  'masterbat*',
  'masterbat3',
  'masterbate',
  'masterbation',
  'masterbations',
  'masturbate',
  'mo-fo',
  'mof0',
  'mofo',
  'mothafuck',
  'mothafucka',
  'mothafuckas',
  'mothafuckaz',
  'mothafucked',
  'mothafucker',
  'mothafuckers',
  'mothafuckin',
  'mothafucking',
  'mothafuckings',
  'mothafucks',
  'mother fucker',
  'motherfuck',
  'motherfucked',
  'motherfucker',
  'motherfuckers',
  'motherfuckin',
  'motherfucking',
  'motherfuckings',
  'motherfuckka',
  'motherfucks',
  'muff',
  'mutha',
  'muthafecker',
  'muthafuckker',
  'muther',
  'mutherfucker',
  'n1gga',
  'n1gger',
  'nazi',
  'nigg3r',
  'nigg4h',
  'nigga',
  'niggah',
  'niggas',
  'niggaz',
  'nigger',
  'niggers',
  'nob',
  'nob jokey',
  'nobhead',
  'nobjocky',
  'nobjokey',
  'numbnuts',
  'nutsack',
  'orgasim',
  'orgasims',
  'orgasm',
  'orgasms',
  'p0rn',
  'pawn',
  'pecker',
  'penis',
  'penisfucker',
  'phonesex',
  'phuck',
  'phuk',
  'phuked',
  'phuking',
  'phukked',
  'phukking',
  'phuks',
  'phuq',
  'pigfucker',
  'pimpis',
  'piss',
  'pissed',
  'pisser',
  'pissers',
  'pisses',
  'pissflaps',
  'pissin',
  'pissing',
  'pissoff',
  'poop',
  'porn',
  'porno',
  'pornography',
  'pornos',
  'prick',
  'pricks',
  'pron',
  'pube',
  'pusse',
  'pussi',
  'pussies',
  'pussy',
  'pussys',
  'rectum',
  'retard',
  'rimjaw',
  'rimming',
  's hit',
  's.o.b.',
  'sadist',
  'schlong',
  'screwing',
  'scroat',
  'scrote',
  'scrotum',
  'semen',
  'sex',
  'sh!+',
  'sh!t',
  'sh1t',
  'shag',
  'shagger',
  'shaggin',
  'shagging',
  'shemale',
  'shi+',
  'shit',
  'shitdick',
  'shite',
  'shited',
  'shitey',
  'shitfuck',
  'shitfull',
  'shithead',
  'shiting',
  'shitings',
  'shits',
  'shitted',
  'shitter',
  'shitters',
  'shitting',
  'shittings',
  'shitty',
  'skank',
  'slut',
  'sluts',
  'smegma',
  'smut',
  'snatch',
  'son-of-a-bitch',
  'spac',
  'spunk',
  's_h_i_t',
  't1tt1e5',
  't1tties',
  'teets',
  'teez',
  'testical',
  'testicle',
  'tit',
  'titfuck',
  'tits',
  'titt',
  'tittie5',
  'tittiefucker',
  'titties',
  'tittyfuck',
  'tittywank',
  'titwank',
  'tosser',
  'turd',
  'tw4t',
  'twat',
  'twathead',
  'twatty',
  'twunt',
  'twunter',
  'v14gra',
  'v1gra',
  'vagina',
  'viagra',
  'vulva',
  'w00se',
  'wank',
  'wanker',
  'wanky',
  'whoar',
  'whore',
  'willies',
  'willy',
  'xrated',
  'xxx',

  // Our own bad words are added here
  'hitler',
  'nazi',
  'badussy',
  'joecandice',
  'ligma',
  'sugma',
  'sugon',
  'wtf',
  'dammit'
]

// These words will only be blocked if they are at word boundaries.
// These words are commonly found within other non-profane words,
// eg `sassy` or `analytics`
export const lessStrictWords = [
  'tit',
  'ass',
  'asses',
  'anal',
  'hell',
  'anus',
  'spac',
  'cok',
  'turd',
  'spac',
  'nob',
  'jap',
  'muff',
  'cipa',
  'cum',
  'kum',
  'pron',
  'lust',
  'bum',
  'pawn',
  'fuk',
  'ssn',
  'social security'
]

// These words (and phrases containing spaces) will not be blocked outright, but
// they are potential red flags. So they will land a note containing them in
// triage, and then we can verify whether the use is appropriate or not before
// the note is made public.
export const redFlagPhrases = [
  'Dahmer',
  'Bundy',
  'Black Dahlia',
  'Zodiac Killer',
  'Charles Manson',
  'Charles Cullen',
  'Richard Ramirez',
  'Patrick Kearney',
  'Paul John Knowles',
  'Aileen Wuornos',
  'Robert Berdella',
  'David Berkowitz',
  'Son of Sam',
  'Robert Hansen',
  'Joseph Paul Franklin',
  'Gary Ridgway',
  'Richard Speck',
  'Arthur Shawcross',
  'Dennis Rader',
  'BTK',
  'John Floyd Thomas',
  'Slenderman',
  'John Wayne Gacy',
  'Ed Gein',
  'Peter Sutcliffe',
  'Edmund Kemper',
  'Jerry Brudos',
  'Albert De Salvo',
  'Henry Lee Lucas',
  'Ottis Toole',
  'John Christie',
  'Andrei Chikatilo',
  'Dennis Nilsen',
  'Issei Sagawa',
  'Rodney Alcala',
  'Samuel Little',
  'Harold Shipman',
  'Randy Kraft',
  'Ian Brady',
  'Myra Hindley',
  'Christopher Lee Watts',
  'Jodi Arias',
  'Luka Magnotta',
  'OJ Simpson',
  'Columbine',
  'Eric Harris',
  'Dylan Klebold',
  'Adam Lanza',
  'Cannibal',
  'Strangler',
  'Rapist',
  'Stabbing',
  'True crime',
  'Creepy pasta'
]
const redFlagPhrasesTrimmed = redFlagPhrases.map((p) => p.replace(/\s/g, ''))

// These words will be blocked in any context, regardless of their location in a string
export const blockAnywhereWords = badwords.filter((w) => !lessStrictWords.includes(w))

const reStringList = blockAnywhereWords
  .map(escapeCharacters)
  .reduce((list, current) => (list === '' ? current : `${list}|${current}`))
const strictBadWordsRE = RegExp(`(${reStringList})`, 'i')
export const strictBadWordsRegexGlobal = RegExp(`(${reStringList})`, 'ig')

const lessStrictReStringList = lessStrictWords
  .reduce((list, current) => (list === '' ? current : `${list}|${current}`))
  .replace(/\+/g, `\\+`)
const lessStrictBadWordsRE = RegExp(`\\b(${lessStrictReStringList})\\b`, 'i')
export const lessStrictBadWordsRegexGlobal = RegExp(`\\b(${lessStrictReStringList})\\b`, 'ig')

const wholeWordBadWordsReStringList = [...badwords, ...lessStrictWords]
  .map((w) => w.replace(/[.*+?^${}()|[\]\\/]/g, '\\$&'))
  .join('|')
const wholeWordBadWordsRE = RegExp(`(?<![\\p{L}\\p{M}])(${wholeWordBadWordsReStringList})(?![\\p{L}\\p{M}])`, 'iu')

const redFlagPhrasesReStringList = redFlagPhrases
  .reduce((list, current) => (list === '' ? current : `${list}|${current}`))
  .replace(/\+/g, `\\+`)
export const redFlagPhrasesRegexGlobal = RegExp(`(${redFlagPhrasesReStringList})`, 'ig')

const redFlagPhrasesTrimmedReStringList = redFlagPhrasesTrimmed
  .reduce((list, current) => (list === '' ? current : `${list}|${current}`))
  .replace(/\+/g, `\\+`)
const redFlagPhrasesTrimmedRE = RegExp(`(${redFlagPhrasesTrimmedReStringList})`, 'i')

/**
 * Checks @param text for profane words.
 * Tests against two lists of words, one strict that returns true if the word is found anywhere in the string,
 * and one less strict that only returns true if the word is surrounded by whitespace or symbols.
 * NOTE: this was built with the intention of filtering profaniy from _usernames and tags_ only.
 *   If you have other filtering needs, build another filter.
 */

export function usernameOrTagContainsBadWord(text: string) {
  const splitText = text.replace(/(\s|_|-|\.|[0-9])/g, ' ')
  return strictBadWordsRE.test(text) || lessStrictBadWordsRE.test(splitText)
}

/**
 * Returns true if a bad word appears in @param name as a whole word. Substring matching would reject
 * real names that happen to contain a bad word, like "Wang" or "Dickinson".
 */
export function fullNameContainsBadWord(name: string) {
  return wholeWordBadWordsRE.test(name)
}

const nonLetters = /[^a-zA-Z]/g

/**
 * Returns true if the text contains any bad words.
 *
 * @param text Text to check for bad words.
 * @returns True if bad words are present, false if it's clean.
 */
export function freetextContainsBadWord(text: string) {
  const splitText = text.replace(nonLetters, ' ')
  return strictBadWordsRE.test(text) || lessStrictBadWordsRE.test(splitText)
}

/**
 * Returns true if the text contains any red flag phrases.
 *
 * @param text Text to check for red flag phrases.
 * @returns True if red flag phrases are present, false if it's clean.
 */
export function containsRedFlagPhrase(text: string) {
  const splitText = text.replace(nonLetters, '')
  return !!redFlagPhrasesTrimmedRE.test(splitText)
}
